import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Partner {
  id: string;
  category: string;
  name: string;
  link: string | null;
  logo_url: string | null;
  address: string | null;
  order_in_category: number | null;
  is_active: boolean;
}

export const usePartners = () => {
  return useQuery({
    queryKey: ['partners'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('partners')
        .select('*')
        .eq('is_active', true)
        .order('order_in_category', { ascending: true, nullsFirst: false })
        .order('name', { ascending: true });

      if (error) {
        throw error;
      }

      return data as Partner[];
    },
  });
};

export const usePartnersByCategory = () => {
  const { data: partners, ...rest } = usePartners();
  
  const categorizedPartners = partners?.reduce((acc, partner) => {
    if (!acc[partner.category]) {
      acc[partner.category] = [];
    }
    acc[partner.category].push(partner);
    return acc;
  }, {} as Record<string, Partner[]>);

  return { data: categorizedPartners, partners, ...rest };
};